import { useEffect } from "react";

export default function usePageMeta(title, description) {
  useEffect(() => {
    document.title = title;
    if (description) {
      const d = document.querySelector('meta[name="description"]');
      if (d) d.setAttribute("content", description);
    }
  }, [title, description]);
}
